<template>
  <div class="wzbleft-wrapper">
    <div class="wzbleft">
      <div class="left-title">
        支部简介
      </div>
      <div class="box dangyuan" :style="{paddingTop:height*0.034+'px',paddingBottom:height*0.034+'px'}">
        <div class="iconfont icon-dangyuan" style="font-size: 30px;padding:9px 5px 0 0"></div>
        <div>成员数：<span style="font-size: 35px">{{info.totalNumber}}</span><span style="font-size: 16px">人</span></div>
      </div>

      <y-scroll :contentArr="leftScroll" :height="height*0.285" :lineNum="1" :width="width*0.234" :time="5000">
        <div slot="scroll" slot-scope="props" class="scroll-wrapper">
          <div v-if="props.todo.text" class="wsq-jianjie" :style="{fontSize:height>750 || width > 1550?'25px':'15px'}">
              {{props.todo.text}}

          </div>
          <div v-else-if="props.todo.img" style="padding-top:1px" :style="{height: height*0.285-5+'px'}">
            <img class='scroll-pic' :src='props.todo.img'  />
          </div>
        </div>
      </y-scroll>

      <div class="wzb-ma" v-if="info.qrcodeUrl" :style="{bottom:height*0.147+'px',height: height*0.215+'px',width:height*0.215+'px'}">
        <img :src="info.qrcodeUrl" style="height: 100%;width: 100%" />
      </div>
    </div>
  </div>
</template>

<script>
  import yScroll from '../../../components/yScroll'
  export default {
    components: {
      yScroll
    },
    data() {
      return {}
    },
    props: {
      height: Number,
      width: Number,
      info: {
        type: Object,
        default: {}
      },
      leftScroll: {
        type: Array,
        default: []
      },
    }
  }
</script>

<style scoped>
  .wzbleft-wrapper{
    width: 530px;
    height: 100%;
    padding: 0 60px
  }
  .wzbleft{
    /*background: #ddd;*/
    height: 100%;
    position: relative;
  }
  .left-title{
    text-align: center;
    font-size:28px;
    font-weight: 600;
    color: #4c4c4c
  }
  .dangyuan{
    color:#ff4500;
    /*padding: 35px 0;*/
    justify-content: center;
    font-size:24px
  }
  .wzb-jianjie{
    /*font-size:25px;*/
    letter-space:1px;
    color:#333;
    line-height: 1.8;
    /*font-size: 25px;*/
  }
  .wzb-ma{
    /*height: 220px;*/
    /*width: 220px;*/
    position: absolute;
    left:50%;
    transform: translateX(-50%);
  }
  .scroll-wrapper{
    padding: 0 15px
  }
  .wsq-jianjie{
    letter-space:1px;
    color:#333;
    line-height: 2;
    padding: 0 8.88%;
    font-size: 25px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 5;
    overflow: hidden;
  }
  .scroll-pic{
    max-width: 100%;
    height: auto;
    width: auto;
    max-height: 100%;
  }
</style>
